import { render, staticRenderFns } from "./AddExtra.vue?vue&type=template&id=194e86b2&"
import script from "./AddExtra.vue?vue&type=script&lang=js&"
export * from "./AddExtra.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports